import { EmotionIconProps } from '@emotion-icons/emotion-icon'

export const PropertyRecordsIcon = (props: EmotionIconProps) => {
  const { fill, color, size } = props
  return (
    <svg width={size} height={size} viewBox={`0 0 18 18`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.5V18H18V7.5L9 0L0 7.5ZM7.87122 6.60452C7.87122 5.85643 8.47765 5.25 9.22574 5.25C9.97381 5.25 10.5803 5.85643 10.5803 6.60452C10.5803 7.35262 9.97383 7.95905 9.22574 7.95905C8.47765 7.95905 7.87122 7.35262 7.87122 6.60452ZM8.17222 15.7581V10.819H7.79597C7.58816 10.819 7.41971 10.6506 7.41971 10.4428V9.54407C7.41971 9.33627 7.58816 9.16782 7.79597 9.16782H9.903C10.1108 9.16782 10.2793 9.33627 10.2793 9.54407V15.759L8.17222 15.7581Z"
        fill={fill || color || 'currentColor'}
      />
    </svg>
  )
}
